import React, { Component } from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from 'gatsby-image';

import passwordSVG from '../../images/password.svg';
import fingerprintSVG from '../../images/fingerprint.svg';
import faceRecognitionSVG from '../../images/face-recognition.svg';

import "./maesh-steps.css"

class MaeshSteps extends Component {

    constructor(props){
        super(props);
        this.state = {
            activeFold : 1
        }
    }

    render() {
      return (
		  <StaticQuery
		  
		  query={
			graphql`
			  query {
				payNowLogo: file(relativePath: { eq: "PayNow.png" }) {
					childImageSharp {
						fixed(width: 100) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				qrCode: file(relativePath: { eq: "qr-code.png" }) {
					childImageSharp {
						fixed(width: 100) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				paylahLogo: file(relativePath: { eq: "apps/paylah.jpg" }) {
					childImageSharp {
						fixed(width: 30) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				ocbcLogo: file(relativePath: { eq: "apps/ocbc.jpg" }) {
					childImageSharp {
						fixed(width: 30) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				uobLogo: file(relativePath: { eq: "apps/uob.jpg" }) {
					childImageSharp {
						fixed(width: 30) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				citiBankLogo: file(relativePath: { eq: "apps/citi-bank.jpg" }) {
					childImageSharp {
						fixed(width: 30) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				hsbcLogo: file(relativePath: { eq: "apps/hsbc.jpg" }) {
					childImageSharp {
						fixed(width: 30) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				standardCharteredLogo: file(relativePath: { eq: "apps/standard-chartered.jpg" }) {
					childImageSharp {
						fixed(width: 30) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				maybankLogo: file(relativePath: { eq: "apps/maybank.jpg" }) {
					childImageSharp {
						fixed(width: 30) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
				bocLogo: file(relativePath: { eq: "apps/bank-of-china.jpg" }) {
					childImageSharp {
						fixed(width: 30) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},				
				icbcLogo: file(relativePath: { eq: "apps/icbc.jpg" }) {
					childImageSharp {
						fixed(width: 30) {
						...GatsbyImageSharpFixed_noBase64
						}
					}
				},
			}`
		  }

		  render={data=>(
			<div>
                <div className="container">	
                    <div className="row instruction-section">
                        <div className="col-md-4">
                            <div className="media flex-column flex-lg-row align-items-center align-items-md-start">
                                <div className="media-body mt-3 mt-md-0 align-self-center">
                                    <Img loading="eager" fixed={data.payNowLogo.childImageSharp.fixed} src="images/PayNow.png" alt="PayNow" className="mt-2 mb-2 maesh-usage-paynow"/>
                                    <p className="maesh-steps-text color-2 m-0">1. Customer selects PayNow powered by Maesh</p>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.activeFold === 1 ? "col-md-4 on-desktop" : "col-md-4 on-desktop d-none"}>
                            <div className="media flex-column flex-lg-row align-items-center align-items-md-start">
                                <div className="media-body mt-3 mt-md-0 align-self-center">
                                    <div className="maesh-usage-step">
                                        <Img loading="eager" fixed={data.qrCode.childImageSharp.fixed} alt="QR-code" className="mt-2 mb-2 ml-3 mr-3 maesh-usage-image"/>
                                    </div>
                                    <p className="maesh-steps-text color-2 m-0">2. Your customer scans the QR code displayed onscreen with any
                                        PayNow app of the <a href="https://www.abs.org.sg/consumer-banking/pay-now"
                                            rel="noreferrer" target="_blank">9 participating banks</a> in Singapore</p>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.activeFold === 2 ? "col-md-4 on-mobile-redirect" : "col-md-4 on-mobile-redirect d-none"}>
                            <div className="media flex-column flex-lg-row align-items-center align-items-md-start">
                                <div className="media-body mt-3 mt-md-0 align-self-center">
                                    <div className="maesh-usage-step">
                                        <Img loading="eager" fixed={data.paylahLogo.childImageSharp.fixed} alt="PayLah! logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
                                        <Img loading="eager" fixed={data.ocbcLogo.childImageSharp.fixed} alt="OCBC Bank logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
                                        <Img loading="eager" fixed={data.uobLogo.childImageSharp.fixed} alt="UOB logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
                                        <Img loading="eager" fixed={data.citiBankLogo.childImageSharp.fixed} alt="Citi Bank logo"
                                            className="mt-2 mb-2 ml-2 mr-2 banks"/>
                                        <Img loading="eager" fixed={data.hsbcLogo.childImageSharp.fixed} alt="HSBC logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
                                        <Img loading="eager" fixed={data.standardCharteredLogo.childImageSharp.fixed} alt="Standard Chartered logo"
                                            className="mt-2 mb-2 ml-2 mr-2 banks"/>
                                        <Img loading="eager" fixed={data.maybankLogo.childImageSharp.fixed} alt="Maybank logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
                                        <Img loading="eager" fixed={data.bocLogo.childImageSharp.fixed} alt="Bank of China logo"
                                            className="mt-2 mb-2 ml-2 mr-2 banks"/>
                                        <Img loading="eager" fixed={data.icbcLogo.childImageSharp.fixed} alt="ICBC logo" className="mt-2 mb-2 ml-2 mr-2 banks"/>
                                    </div>
                                    <p className="maesh-steps-text color-2 m-0">2. Your customer chooses any PayNow app of the <a
                                            href="https://www.abs.org.sg/consumer-banking/pay-now" rel="noreferrer"
                                            target="_blank">9 participating banks</a> in Singapore and gets redirected</p>
                                </div>
                            </div>
                        </div>
                        <div className={this.state.activeFold === 3 ? "col-md-4 on-mobile-qr" : "col-md-4 on-mobile-qr d-none"}>
                            <div className="media flex-column flex-lg-row align-items-center align-items-md-start">
                                <div className="media-body mt-3 mt-md-0 align-self-center">
                                    <div className="maesh-usage-step">
                                        <Img loading="eager" fixed={data.qrCode.childImageSharp.fixed} alt="QR-code" className="mt-2 mb-2 ml-3 mr-3 maesh-usage-image"/>
                                    </div>
                                    <p className="maesh-steps-text color-2 m-0">2. Your customer can upload the QR code screenshot into any
                                        PayNow app of the <a href="https://www.abs.org.sg/consumer-banking/pay-now"
                                            rel="noreferrer" target="_blank">9 participating banks</a> in Singapore</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="media flex-column flex-lg-row align-items-center align-items-md-start">
                                <div className="media-body mt-3 mt-md-0 align-self-center">
                                    <div className="maesh-usage-step">
                                        <img src={passwordSVG} alt="Password Authentication" className="mt-2 mb-2 maesh-usage-icon"/>
                                        <img src={fingerprintSVG} alt="Fingerprint Authentication" className="mt-2 mb-2 maesh-usage-icon"/>
                                        <img src={faceRecognitionSVG} alt="Face Recognition" className="mt-2 mb-2 maesh-usage-icon" />
                                    </div>
                                    <p className="maesh-steps-text color-2 m-0">3. The customer authorizes the payment in app with bank grade security
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="instruction-toggle">
                    <div>
                        <button onClick={()=>this.setState({activeFold: 1})} type="button" className={this.state.activeFold===1? "btn btn-rounded btn-3 shadow mt-1 px-4 active-step-button" : "btn btn-rounded btn-3 shadow mt-1 px-4"} id="desktop">On
                            Desktop</button>
                    </div>
                    <div>
                        <button onClick={()=>this.setState({activeFold: 2})} type="button" className={this.state.activeFold===2? "btn btn-rounded btn-3 shadow mt-1 px-4 active-step-button" : "btn btn-rounded btn-3 shadow mt-1 px-4"} id="mobile-qr">On Mobile
                            (QR)</button>
                    </div>
                    <div>
                        <p className="emphasis mt-0 mb-1 coming-soon"><strong>COMING SOON</strong></p>
                        <button onClick={()=>this.setState({activeFold: 3})} type="button" className={this.state.activeFold===3? "btn btn-rounded btn-3 shadow mt-1 px-4 active-step-button" : "btn btn-rounded btn-3 shadow mt-1 px-4"} id="mobile-redirect">On Mobile
                            (Redirect)</button>
                    </div>
                </div>
            </div>
		  )}
		  />
      );
    }
}

export default MaeshSteps;

